/**
 * @title product-redirect-helper.js: Sub-Module of browse feature optimized
 * for home page.
 * @description The module contains extracted functions for optimization of 
 * extendedaddtocart.js used on home page.
 * @dependency
 */
define([], function() {
	return {
		redirectToPage: function(event){
			let productURL = $(event.currentTarget).closest(".product-tile-set").attr("data-pdp-url");
	    	window.location.href = productURL;
        }
	}
});


// WEBPACK FOOTER //
// ./js/browse/product-redirect-helper.js